import React, { useCallback, useEffect, useState } from "react";
import Modal from "components/global/modal";
import Button from "components/button/button";
import ModalHeader from "components/global/modal-header";
import LoadingIndicator from "assets/svg/loading-indicator";
import _ from "lodash";
import CustomCheckbox from "components/checkbox/custom-checkbox";
import { KB, MB, maxUploadSize } from "utils/constant";
import { useDialogHook } from "utils/customhooks";
import UploadSizeModal from "components/file-upload/upload-size-modal";
import DropzoneUploadGallery from "./dropzone-gallery";

import { ImageDisplay } from "./add-photo-draggable-modal";
import { useTranslation } from "react-i18next";


export default function EditPhotoDraggableModal({
  hide,
  userData,
  profile,
  photos = [],
  setPhotos=()=>{},
  onUpdateImages = async () => {},
  ...props }) {
  const { http } = global.services;
 
  const [preview, setPreview] = useState([]);
  const [adultContent, setAdultContent] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const uploadSizeModal = useDialogHook(UploadSizeModal);
  const [dataSubmit,setDataSumbit] = useState([]);
  const {t} = useTranslation();
 
  React.useEffect(() => {
    if (photos) {
      setPhotoPreview(photos);
    }
  }, [photos]);


  const setPhotoPreview = (_photo = photos) => {
    /**
     * @type {Array<{ id: string, name: string, size: number, path: string}>}
     */
    const _previews = [];
    console.log("Galleries List");
    console.log(_photo);
    _photo.forEach((file, index) => {
      let size = _photo[index]?.media?.file_size;
  
      if (size > MB) {
        size /= MB;
        size = `${Math.round(size * 10) / 10}MB`;
      } else if (size > KB) {
        size /= KB;
        size = `${Math.round(size * 10) / 10}KB`;
      } else {
        size = `${size}B`;
      }

      _previews.push({
        id: _photo[index].id,
        name: `${_photo[index].media?.title}.${_photo[index].media?.file_extension}`,
        title: _photo[index].media?.title,
        size: size,
        path: _photo[index].media?.webp_url || _photo[index].media?.url,
        order:index,
        media_id: _photo[index]?.media_id || null,
        rename:false,
        file_extension:_photo[index].media?.file_extension,
        action:null
      });
    });
    setPreview(_previews); 
    setDataSumbit(_previews);
  }

  /**
   * 
   * @param {string} index 
   */
  const removeUploadedPhoto = (index,id) => {
    console.log('state', preview);
    const updatedPhotos = preview.filter((_, i) => _.id !== id); 
    setPreview(updatedPhotos);

    setDataSumbit(dataSubmit.map(item => 
        item.id === id ? { ...item, action: 'delete' } : item
    )) 
  }

  const submit = async () => {
    setSubmitLoading(true);

    let errors = {};
    setErrorMessages(errors);

    try { 
      let payload = new FormData();
      let deleteItems = dataSubmit.filter(item=> item.action === 'delete').map(item => item.id);
      let renameItems = dataSubmit.filter(item=> item.action === 'rename');
      payload.append('delete',JSON.stringify(deleteItems))
      payload.append('rename',JSON.stringify(renameItems))
      payload.append('list',JSON.stringify(preview));
      console.log(payload)  
      let newGallery = preview.map(item => {
        let matchedPhoto = photos.find(photo => photo.id === item.id);
        if (matchedPhoto) {
            return {
                ...matchedPhoto,
                order: item.order,
                media: {
                    ...matchedPhoto.media,
                    title: item.title
                }
            };
        }
    }).filter(Boolean); 
 
      const upload = await onUpdateImages(payload,newGallery);
      if (upload === 'success') {
        hide(true);
      }
    } catch(err) {
      if (err.status === 422) {
        errors = {
          ...errors,
          ...err.data?.errors,
        };

        console.log('::AddPhotoModal > 422 errors', errors);

        return setErrorMessages((prev) => ({
          ...prev,
          ...errors
        }));
      }

      console.log('::AddPhotoModal > error', err);
      setSubmitLoading(false);
    } finally {
      setSubmitLoading(false);
    }
  };

  const toggleAdultContentCheckbox = (e) => {
    setAdultContent(!e.target.checked);
  }

  const showUploadSizeModalError = () => {
    uploadSizeModal({}, (callback) => {
      console.log('callback', callback)
    })
  }

  return (
    <div className="smooth-dnd-parent">
        <Modal
        width="w-full md:w-15/20 2md:w-11/20 lg:w-9/20 xl:w-6/20"
        contentClassName="rounded-lg overflow-auto custom-scroll"
        wrapperClassName="overflow-visible">
        <div className="w-full">
            {/* header */}
            <ModalHeader title={`Rename Files ${preview.length} `} hide={hide} />
            {/* content */}
            <div className="px-8.5 pt-3 pb-4">
            {/* profile */}
            <div className="pb-2">
              <p>Re-order photos by dragging up or down</p>
              <p>Edit photo names gathered from the files names</p>
            </div>
            <div className="flex flex-column">

                    {Array.isArray(preview) && (
                        <div className="mt-2">
                        <ImageDisplay
                            previews={preview}
                            onRemove ={()=>{}}
                            setPreview={setPreview}
                            photo={photos}
                            removeUploadedPhoto={removeUploadedPhoto}
                            action="edit"
                            dataSubmit={dataSubmit}
                            setDataSumbit={setDataSumbit}
                            withExtension={false}
                        />
                        </div>
                    )}

                <div className="flex space-x-4.5 items-center mt-8 checkbox-v2">
                {
                  photos.length > 0 &&
                  <div>
                    <CustomCheckbox
                    label={
                        <p className="checkbox-text">
                       {
                          photos.length > 1 
                          ? t('thisFileDoesNotContainAdult2', {file: t('photos')?.toLowerCase?.() })
                          : t('thisFileDoesNotContainAdult', {file: t('photo') })
                        }
                        </p>
                    }
                    name={"termsAndConditions"}
                    checked={!adultContent}
                    onChange={(e) => toggleAdultContentCheckbox(e)}
                    v2={true}
                    />
                </div>
                }
                </div>

                {/* Footer */}
                <div className="absolute left-0 w-full custom-modal-footer-separator border-t border-gray my-4"></div>
                <div className="w-full flex items-center justify-start 1sm:justify-end space-x-2 mt-10">
                <Button
                    buttonName="Cancel"
                    buttonClass="bg-thBg py-4 px-8 hover:bg-gray"
                    buttonTextClass="text-black text-sm font-semibold"
                    onClick={() => hide()}
                    disabled={submitLoading || preview.length < 0 }
                />
                <Button
                    key="save-btn-category"
                    buttonName="Save"
                    buttonClass="bg-primary py-4 px-8 hover:bg-darkPrimary"
                    buttonTextClass="text-white text-sm font-semibold flex items-center"
                    onClick={submit}
                    disabled={submitLoading || preview.length <= 0}
                    loadingIcon={
                    submitLoading ? (
                        <LoadingIndicator className="text-white w-4 h-4 ml-2" />
                    ) : null
                    }
                />
                </div>
            </div>
            </div>
            {/* end content */}
        </div>
        </Modal>
    </div>
  );
} 
 
